<template>
  <v-container fluid class="pl-md-5 pb-16">
    <h1 class="text-h5 mb-5 mt-5">{{ $t("Messages") }}</h1>
    <v-row>
      <v-col cols="12">
        <v-card width="100%">
          <v-toolbar color="light-blue" dark>
            <v-toolbar-title>{{ $t("AllMessages") }}</v-toolbar-title>
          </v-toolbar>
          <v-list>
            <v-list-item-group v-model="selectedItem" color="light-blue">
              <v-list-item
                v-for="(item, i) in list"
                :key="i"
                :to="{
                  name: 'MessageViewComponent',
                  params: { id: item._id }
                }"
              >
                <v-list-item-content>
                  <v-list-item-title v-text="item.topic"></v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-chip v-text="item.count"></v-chip>
                </v-list-item-action>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import timeoutMixin from "@/mixins/timeoutMixin.js";
import AuthService from "@/services/AuthService";
import { format } from "date-fns";

export default {
  name: "MessageComponent",
  mixins: [timeoutMixin],
  data() {
    return {
      format,
      error: null,
      list: null,
      selectedItem: 1
    };
  },
  created() {
    if (this.$store.getters.isLoggedIn) {
      var token = this.$store.state.token;
      AuthService.getMessageTopics({
        headers: { Authorization: "Bearer " + token }
      })
        .then(result => {
          this.list = result.data.topics;
        })
        .catch(err => {
          this.error = err.response.data.error;
        });
    }
  },
  methods: {}
};
</script>

<style></style>
